<template>
    <div
        class="roadmap-point"
        :style="{ top: level.position.y + 'px', left: level.position.x + 'px' }"
    >
        <img :src="level.img" class="point-icon" alt="level-image"/>
    </div>
</template>

<script>
export default {
    name: 'RoadmapPoint',
    props: {
        level: { type: Object, required: true }
    }
}
</script>

<style scoped>
.roadmap-point {
    position: absolute;
    text-align: center;
    transform: translate(-50%, -50%);
}
.point-icon {
    width: 230px;
    height: auto;
}
@media (max-width: 1024px) {
    .point-icon {
        width: 110px;
        height: auto;
    }
}
</style>
